import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import { CONVENIENCE_DISPATCH_DELIVERIES_QUERY_KEY } from './useConvenienceDispatchDeliveries.query';

/**
 * 当日 (Shift × Truck = ShiftTruck) 単位で「車番」を保存する。
 * 配車 (leg_run_operation) の有無に関わらず編集できる。
 *
 * backend は同時に紐付く全 leg_run.truck_number にも同じ値を書き戻すため、
 * 帳票・CSV など旧経路 (leg_run.truck_number 参照) との互換も保たれる。
 *
 * 表示優先度は adapter で:
 *   shift_truck.truck_number > leg_run.truck_number > truck.truck_number
 */
export const useUpdateShiftTruckTruckNumberMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (args: { shiftTruckId: number; truckNumber: string }) => {
      await axios.patch(
        `/api/v5/plannings/shift_trucks/${args.shiftTruckId}/truck_number`,
        { data: { truck_number: args.truckNumber } },
      );
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries({ queryKey: [CONVENIENCE_DISPATCH_DELIVERIES_QUERY_KEY] });
      },
    },
  );
};
